import React, {useEffect} from "react";
import {
  Box, 
  Grid, 
  Typography,
  FormControlLabel, 
  Checkbox,
  List,
  ListItem,
  ListItemText
} from "@mui/material";
import RegisterStyles from "../../assets/css/register.styles"; 
import { RegisterProps } from "./registerProps";  
import { GeneralStyles } from "../../assets/css/general.styles";
import CustomLabeledTextField from "../../components/customTextField/customLabeledTextField"; 
import {  kuwaitPhoneNumberDigits, kuwaitPhoneNumberRegex } from "../../constants/registerConstants";
import theme from "../../themes/index.en";
import { ValidatableComponent } from "./validatableComponent"; 
import { RegisterTouched } from "./registerTouched";
import { InvestorModel } from "../../models/models/investorModel";
import { InvestorFatcaModel } from "../../models/models/investorFatcaModel";
import { Countries } from "../../constants/enums";

const FATCA: ValidatableComponent = ({
  formData,
  setFormData,
  touched,
  setTouched,
  countries,
  t,
  isRTL
}) => {  
 
  const fatcaQuestions = [
    {
      label:"internalRevenueServiceAgreement",
      field: "hasInternalRevenueServiceAgreement",
    },
    {
      label: "transferFundsInstruction",
      field: "hasTransferFundsInstruction",
    },
    {
      label:"attorneyPower",
      field: "hasAttorneyPower",
    }, 
  ]; 
 
  const declarations = [
    "declaration1",
    "declaration2",
    "declaration3",
    "declaration4",
    "declaration5",
    "declaration6",
];

    const handleTelephoneNumberBlur = () => { 
      if((formData.fatca.internationalMobileNumber === null || (formData.fatca.internationalMobileCountryId === Countries.KuwaitId &&  formData.fatca.internationalMobileNumber !== null && (!kuwaitPhoneNumberRegex.test(formData.fatca.internationalMobileNumber.toString()) || formData.fatca.internationalMobileNumber.toString().length != kuwaitPhoneNumberDigits)))){
        setTouched((prevData) => ({
            ...prevData,
            internationalMobileNumber: true,
        }))
    }else{
      setTouched((prevData) => ({
        ...prevData,
        internationalMobileNumber: false,
    }))
    }
    }; 

    useEffect(() => {
        if (formData.fatca.internationalMobileCountryId) {
            handleTelephoneNumberBlur();
        }
      }, [formData.fatca.internationalMobileCountryId]);

      
      

  return (
    <Box
    display="flex"
    flexDirection="column"
    gap={2}
    mb={2}
    pl={5}
    sx={{
      textAlign: isRTL ? "right" : "left",
      direction: isRTL ? "rtl" : "ltr", 
      marginRight: '50px', 
    }}
  >
        <Box sx={RegisterStyles.boxStyle}>
            <Grid container item xs={12} spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="body1" sx={{ fontWeight: "500" }}>
                        {t('actualBeneficiary')}
                    </Typography>
                {touched.hasUsaRelation  && (
                    <Typography variant="h6" gutterBottom p={1} sx={{ color: theme.palette.error.main }}>
                        {t('chooseOneOption') }
                    </Typography>
                )}  
                </Grid> 
                <Grid item xs={6}>
                    <FormControlLabel
                    control={
                        <Checkbox
                            style={GeneralStyles.checkBoxStyle}
                            checked={formData.fatca.hasUsaRelation===true}
                            onChange={() =>
                                setFormData({
                                  ...formData,
                                  fatca: {
                                    ...formData.fatca, 
                                    hasUsaRelation: true,
                                  },
                                })
                              }
                        />
                    }
                    label={t('yes')}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormControlLabel
                    control={
                        <Checkbox
                            style={GeneralStyles.checkBoxStyle}
                            checked={formData.fatca.hasUsaRelation===false}
                            onChange={() =>
                                setFormData({
                                  ...formData,
                                  fatca: {
                                    ...formData.fatca,
                                    hasUsaRelation: false,
                                  },
                                })
                              }
                        />
                    }
                    label={t('no')}
                    />
                </Grid>
            </Grid>
        </Box>  
        {formData.fatca.hasUsaRelation && (
            <Box sx={RegisterStyles.boxStyle}> 
                <Grid container item xs={12} sm={12} md={12} spacing={1}>
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField
                            label={t('bornUSA')}
                            isRTL={isRTL}
                            name="bornPlace" 
                            type="text"
                            value={formData.fatca.bornPlace}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    bornPlace:  e.target.value
                                  },
                                }))
                              }   
                            required={true} 
                            error={touched.bornPlace && formData.fatca.bornPlace.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.bornPlace && formData.fatca.bornPlace.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('passportUSA')}
                            isRTL={isRTL}
                            name="passportHolder" 
                            type="text"
                            value={formData.fatca.passportHolder}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    passportHolder:  e.target.value
                                  },
                                }))
                              }   
                            required={true} 
                            error={touched.passportHolder && formData.fatca.passportHolder.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.passportHolder && formData.fatca.passportHolder.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('socialSecurityNumber')}
                            isRTL={isRTL}
                            name="socialSecurityNumber" 
                            type="text"
                            value={formData.fatca.socialSecurityNumber}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    socialSecurityNumber:  e.target.value
                                  },
                                }))
                              }  
                            required={true} 
                            error={touched.socialSecurityNumber && formData.fatca.socialSecurityNumber.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.socialSecurityNumber && formData.fatca.socialSecurityNumber.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                </Grid> 
                <Grid container item xs={12} sm={12} md={12} spacing={1}>
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('greenCardNumber')}
                            isRTL={isRTL}
                            name="greenCardNumber" 
                            type="text"
                            value={formData.fatca.greenCardNumber}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    greenCardNumber:  e.target.value
                                  },
                                }))
                              }   
                            required={true} 
                            error={touched.greenCardNumber && formData.fatca.greenCardNumber.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.greenCardNumber && formData.fatca.greenCardNumber.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('bankAccountNumber')}
                            isRTL={isRTL}
                            name="bankAccountNumber" 
                            type="text"
                            value={formData.fatca.bankAccountNumber}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    bankAccountNumber:  e.target.value
                                  },
                                }))
                              }   
                            required={true} 
                            error={touched.bankAccountNumber && formData.fatca.bankAccountNumber.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.bankAccountNumber && formData.fatca.bankAccountNumber.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('residenceAddress')}
                            isRTL={isRTL}
                            name="residenceAddress" 
                            type="text"
                            value={formData.fatca.residenceAddress}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    residenceAddress:  e.target.value
                                  },
                                }))
                              }  
                            required={true} 
                            error={touched.residenceAddress && formData.fatca.residenceAddress.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.residenceAddress && formData.fatca.residenceAddress.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                </Grid> 
                <Grid container item xs={12} sm={12} md={12} spacing={1}>
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('holdMailAddress')}
                            isRTL={isRTL}
                            name="holdMailAddress" 
                            type="text"
                            value={formData.fatca.holdMailAddress}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    holdMailAddress:  e.target.value
                                  },
                                }))
                              }   
                            required={true} 
                            error={touched.holdMailAddress && formData.fatca.holdMailAddress.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.holdMailAddress && formData.fatca.holdMailAddress.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('internationalMobileNumber')}
                            isRTL={isRTL}
                            name="internationalMobileNumber"
                            type="text"
                            required={true}
                            value={formData.fatca.internationalMobileNumber} 
                            onChange={(e) =>{ 
                                const { value } = e.target;
                                if (!isNaN(Number(value)) || value === "") {
                                    setFormData((prevData) => ({
                                    ...prevData,
                                    fatca: {
                                        ...prevData.fatca,
                                        internationalMobileNumber:  Number(value)
                                    },
                                    }))
                                }
                            }} 
                            isPhoneNumber={true}
                            countryCode={formData.fatca.internationalMobileCountryId || 0}
                            countryCodes={countries || []} 
                            onCountryCodeChange={(countryId) => 
                              setFormData((prevData) => ({
                                ...prevData,
                                fatca: {
                                    ...prevData.fatca,
                                    internationalMobileCountryId: countryId
                                },
                                }))
                            }
                            onBlur={handleTelephoneNumberBlur}
                            error={touched.internationalMobileNumber && ((formData.fatca.internationalMobileNumber === null || (formData.fatca.internationalMobileCountryId === Countries.KuwaitId &&formData.fatca.internationalMobileNumber !== null && (!kuwaitPhoneNumberRegex.test(formData.fatca.internationalMobileNumber.toString()) || formData.fatca.internationalMobileNumber.toString().length != kuwaitPhoneNumberDigits))))}
                            helperText={(touched.internationalMobileNumber &&formData.fatca.internationalMobileNumber === null &&  formData.fatca.internationalMobileCountryId !== Countries.KuwaitId
                               ? `${t('mandatoryField')}`
                              :(touched.internationalMobileNumber && (formData.fatca.internationalMobileNumber === null || ( formData.fatca.internationalMobileCountryId === Countries.KuwaitId && formData.fatca.internationalMobileNumber !== null && (!kuwaitPhoneNumberRegex.test(formData.fatca.internationalMobileNumber.toString()) || formData.fatca.internationalMobileNumber.toString().length != kuwaitPhoneNumberDigits))))) ? `${t('phoneNumberValidation')}` : ''}
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('outsideKuwaitTaxIdentificationNumber')}
                            isRTL={isRTL}
                            name="outsideKuwaitTaxIdentificationNumber" 
                            type="text"
                            value={formData.fatca.outsideKuwaitTaxIdentificationNumber}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    outsideKuwaitTaxIdentificationNumber:  e.target.value
                                  },
                                }))
                              } 
                            required={true} 
                            error={touched.outsideKuwaitTaxIdentificationNumber && formData.fatca.outsideKuwaitTaxIdentificationNumber.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.outsideKuwaitTaxIdentificationNumber && formData.fatca.outsideKuwaitTaxIdentificationNumber.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                </Grid>
                <Grid container item xs={12} sm={12} md={12} spacing={1}>
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField
                            label={t('usaTaxIdentificationNumber')}
                            isRTL={isRTL}
                            name="usaTaxIdentificationNumber" 
                            type="text"
                            value={formData.fatca.usaTaxIdentificationNumber}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    usaTaxIdentificationNumber:  e.target.value
                                  },
                                }))
                              }  
                            required={true} 
                            error={touched.usaTaxIdentificationNumber && formData.fatca.usaTaxIdentificationNumber.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.usaTaxIdentificationNumber && formData.fatca.usaTaxIdentificationNumber.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('personalEmail')}
                            isRTL={isRTL}
                            name="personalEmail" 
                            type="text"
                            value={formData.fatca.personalEmail}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    personalEmail:  e.target.value
                                  },
                                }))
                              } 
                            required={true} 
                            error={touched.personalEmail && formData.fatca.personalEmail.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.personalEmail && formData.fatca.personalEmail.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField
                            label={t('designation')}
                            isRTL={isRTL}
                            name="designationId" 
                            type="text"
                            value={formData.fatca.designationId}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    designationId:  Number(e.target.value)
                                  },
                                }))
                              } 
                            required={true} 
                            error={touched.designationId && formData.fatca.designationId === null && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.designationId && formData.fatca.designationId === null && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                </Grid>  
                <Grid container item xs={12} sm={12} md={12} spacing={1}>
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField
                             label={t('employerName')}
                             isRTL={isRTL}
                            name="employerName" 
                            type="text"
                            value={formData.fatca.employerName}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    employerName:  e.target.value
                                  },
                                }))
                              }  
                            required={true} 
                            error={touched.employerName && formData.fatca.employerName.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.employerName && formData.fatca.employerName.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField
                            label={t('employerAddress')}
                            name="employerAddress"
                            isRTL={isRTL} 
                            type="text"
                            value={formData.fatca.employerAddress}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    employerAddress:  e.target.value
                                  },
                                }))
                              }  
                            required={true} 
                            error={touched.employerAddress && formData.fatca.employerAddress.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.employerAddress && formData.fatca.employerAddress.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                    <Grid item xs={12} sm={4}>
                        <CustomLabeledTextField 
                            label={t('employerContactDetails')}
                            isRTL={isRTL} 
                            name="employerContactDetails" 
                            type="text"
                            value={formData.fatca.employerContactDetails}
                            onChange={(e) =>
                                setFormData((prevData) => ({
                                  ...prevData,
                                  fatca: {
                                    ...prevData.fatca,
                                    employerContactDetails:  e.target.value
                                  },
                                }))
                              }    
                            required={true} 
                            error={touched.employerContactDetails && formData.fatca.employerContactDetails.trim() === "" && formData.fatca.hasUsaRelation}
                            helperText={
                                touched.employerContactDetails && formData.fatca.employerContactDetails.trim() === "" && formData.fatca.hasUsaRelation
                                ? t('mandatoryField')
                                : ""
                            }
                        />
                    </Grid> 
                </Grid>  
            </Box>
        )}
        <Box sx={RegisterStyles.boxStyle}> 
        <Grid container spacing={2}>
        {touched.fatcaQuestions  && (
            <Typography variant="h6" gutterBottom p={1} sx={{ color: theme.palette.error.main }}>
                {t('chooseOneOption') }
            </Typography>
        )}  
          {fatcaQuestions.map(({ label, field }) => (
            <Grid container item xs={12} spacing={1} key={field}>
              <Grid item xs={12}>
                <Typography variant="body1" sx={{ fontWeight: "500" }}>
                  {t(`${label}`)}
                </Typography>
              </Grid> 
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      style={GeneralStyles.checkBoxStyle}  
                      checked={formData.fatca[field as keyof InvestorFatcaModel] === true}
                      onChange={(e) =>
                        setFormData((prevData) => ({
                          ...prevData,
                          fatca: {
                            ...prevData.fatca,
                            [field]: e.target.checked ? true : null,
                          },
                        }))
                      }
                    />
                  }
                  label={t('yes')}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      style={GeneralStyles.checkBoxStyle}
                      checked={formData.fatca[field as keyof InvestorFatcaModel] === false}
                      onChange={(e) =>
                        setFormData((prevData) => ({
                          ...prevData,
                          fatca: {
                            ...prevData.fatca,
                            [field]: e.target.checked ? false: null,
                          },
                        }))
                      }
                    />
                  }
                  label={t('no')}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
        </Box> 
        <Box sx={RegisterStyles.boxColoredStyle}> 
            <Grid container spacing={2}> 
                <Grid container item xs={12} spacing={1}>
                     <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold'}}>
                         {t('declarations')}
                    </Typography>
                    <List>
                        {declarations.map((text, index) => (
                            <ListItem key={index} alignItems="flex-start">
                                <ListItemText
                                    primary={`${index + 1}. ${t(text)}`}
                                    primaryTypographyProps={{
                                        variant: "body1",
                                        component: "p",
                                        sx: { textAlign: "justify" }
                                    }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </Grid>
        </Box>
    </Box>
  );
};

FATCA.validate = (formData: InvestorModel): RegisterTouched => {
    const newTouched = {
        hasUsaRelation: formData.fatca.hasUsaRelation === null,
        fatcaQuestions: formData.fatca.hasInternalRevenueServiceAgreement === null ||
                        formData.fatca.hasTransferFundsInstruction === null ||  
                        formData.fatca.hasAttorneyPower === null, 
        bornPlace : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.bornPlace.trim() === "" ,
        passportHolder : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.passportHolder.trim() === "" ,
        socialSecurityNumber : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.socialSecurityNumber.trim() === "" , 
        greenCardNumber : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.greenCardNumber.trim() === "" ,
        bankAccountNumber : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.bankAccountNumber.trim() === "" ,
        residenceAddress : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.residenceAddress.trim() === "" , 
        holdMailAddress : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.holdMailAddress.trim() === "" ,
        outsideKuwaitTaxIdentificationNumber : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.outsideKuwaitTaxIdentificationNumber.trim() === "" ,
        usaTaxIdentificationNumber : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.usaTaxIdentificationNumber.trim() === "" ,
        personalEmail : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.personalEmail.trim() === "" ,
        designationId : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.designationId === null ,
        employerName : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.employerName.trim() === "" ,
        employerAddress : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.employerAddress.trim() === "" ,
        employerContactDetails : formData.fatca.hasUsaRelation !== null && formData.fatca.hasUsaRelation && formData.fatca.employerContactDetails.trim() === "" , 
       
      };
    return (newTouched)
};
export default FATCA;
